import React from "react";
import logo from "./images/rusty-bucket-logo.png";
import * as styles from "./styles.module.scss";

export default () => (
  <div className={styles.container}>
    <img src={logo} />
  </div>
);
